import { Partner } from '@hub-services/partner';
import { createReducer, on } from '@ngrx/store';
import { PartnerStatusFilter } from '../../admin/admin-partners/partner-status-filter.enum';
import { PartnerType } from '../../admin/admin-partners/partner-type.enum';
import * as PartnersListActions from './partners-list.actions';

export const featureKey = 'partnersList';

export interface HubPartnersListState {
  partners: Partner[];
  partnerType: PartnerType | null,
  status: PartnerStatusFilter,
}

export const initialState: HubPartnersListState = {
  partners: [],
  partnerType: null,
  status: PartnerStatusFilter.ACTIVE,
};

export const reducer = createReducer(
  initialState,

  on(PartnersListActions.setPartners, (state, action) => ({
    ...state,
    partners: action.partners,
  })),
  on(PartnersListActions.setStatus, (state, action) => ({
    ...state,
    status: action.status,
  })),
  on(PartnersListActions.setPartnerType, (state, action) => ({
    ...state,
    partnerType: action.partnerType,
  })),
  on(PartnersListActions.updatePartnerInStore, (state, action) => {
    const tmpState: HubPartnersListState = JSON.parse(JSON.stringify(state));
    const idx = tmpState.partners.findIndex(p => p.id === action.partner.id);
    // No-op if the partner isn't in the list — findIndex returning -1 used directly as an
    // index would silently attach a `-1` property to the array instead of updating an entry
    // (same footgun as selected-partner.reducer's updateUserInStore, see 429b494f4).
    if (idx === -1) return state;
    tmpState.partners[idx] = action.partner;

    return {
      ...tmpState
    }
  }),
  on(PartnersListActions.resetPartners, state => ({
    ...state,
    ...initialState,
  })),

);
